document.addEventListener('DOMContentLoaded', function () {

  //function to check and return true when clicked outside of an element
  const onClickOutside = (element, callback) => {
    document.addEventListener('click', e => {
      if (!element.includes(e.target)) callback();
    });
  };
  
  //close search bas when clicked outside that element
  // onClickOutside('#searchBar', () => { 
  //   // console.log('Hello');
  //   document.querySelector('#searchBar').value = '';
  //   document.querySelector('.custom-search-wrapper #main_div').classList.remove('active');
  // });

  //megamenu functionality
  let all_megamenu_links = document.querySelectorAll('li.has-mega-menu');
  if(all_megamenu_links){
    all_megamenu_links.forEach(function(liEle){
      
      //let timeoutId;
      
      liEle.addEventListener("mouseover", function(e) {
        e.preventDefault();
        
        // Clear any existing timeout
        //clearTimeout(timeoutId);

        // Set a new timeout to show the dropdown after 200 milliseconds
        // timeoutId = setTimeout(function () {
        //   liEle.querySelector('.item-link.dropdown').nextElementSibling.classList.add('active');
        // }, 200);             
        
        liEle.querySelector('.item-link.dropdown').nextElementSibling.classList.add('active');
        
      }, true);
      liEle.addEventListener("mouseleave", function(e) {
        e.preventDefault();
        
        // Clear the timeout if user leaves before it triggers
        // clearTimeout(timeoutId);
        
        liEle.querySelector('.item-link.dropdown').nextElementSibling.classList.remove('active');
        
      }, true);
      
      liEle.querySelector('.item-link.dropdown').addEventListener('touchstart', function(ele){
        let link_data_title = liEle.querySelector('.item-link.dropdown').getAttribute('data-title');
        let megamenus = document.querySelectorAll('.has-mega-menu .mega-menu');
        megamenus.forEach(function(el){          
          let menu_data_title = el.getAttribute('data-title');
          if(link_data_title == menu_data_title){
            el.classList.toggle('active');
          }else{
            el.classList.remove('active');
          }
        });
      });
      
    });
  }
  
  //megamenu toggle in mobile
  let mega_menu_mobile_toggle_btn = document.querySelector('button.menu-toggle');
  if(mega_menu_mobile_toggle_btn){
    mega_menu_mobile_toggle_btn.addEventListener('touchstart', function(){      
      mega_menu_mobile_toggle_btn.classList.toggle('active');
      let navigation = document.querySelector('section.navigation-wrapper');
      navigation.classList.toggle('active');
    });
  }

  //megamenu's submenu view all toggle
  // let menu_lists_all = document.querySelectorAll('.mega-menu.menu-list .sub-menu.list .sm-item');
  // if(menu_lists_all){
  //   menu_lists_all.forEach(function(menu_li_ele){      
  //     let viewAllToggle = menu_li_ele.querySelector('span#viewAllToggle');
  //     if(viewAllToggle){
  //       viewAllToggle.addEventListener('click', function(){
  //         let links_wrap = menu_li_ele.querySelector('.sm-links-wrap');
  //         links_wrap.classList.toggle('active');
  //         if(viewAllToggle.innerHTML == 'View All'){
  //           viewAllToggle.innerHTML = 'View Less';
  //         }else{            
  //           viewAllToggle.innerHTML = 'View All';
  //         }
  //       });
  //     }  
  //   });
  // }

  
  //account dropdown toggle
  let account_wrap = document.querySelector('.account-wrap.wrap-sec');
  if(account_wrap){  
    //account link btn click
    let account_toggle_link = account_wrap.querySelector('.info-link.dropdown');
    account_toggle_link.addEventListener("mouseover", function(e) {
      e.preventDefault();
      account_wrap.querySelector('ul.info-dropdown').classList.add('active');
    }, true);
    account_toggle_link.addEventListener("mouseleave", function(e) {
      e.preventDefault();
      account_wrap.querySelector('ul.info-dropdown').classList.remove('active');
    }, true);
    account_wrap.querySelector('.info-link.dropdown .text').addEventListener('touchstart', function(e) {
      e.preventDefault();
      account_wrap.querySelector('ul.info-dropdown').classList.toggle('active');
    });
    //account icon click
    let account_toggle_icon = account_wrap.querySelector('.icon-wrap');
    //console.log('account_toggle_icon', account_toggle_icon)
    account_toggle_icon.addEventListener('touchstart', function(e) {
      e.preventDefault();
      account_wrap.querySelector('ul.info-dropdown').classList.toggle('active');
    });
  }


  
  //mobile search open/close functionality
  //open search
  let mobileSearchOpen = document.querySelector('#mobileSearchOpen');
  if(mobileSearchOpen){
    mobileSearchOpen.addEventListener('click', function(){
      document.querySelector('.custom-search-wrapper').classList.add('mobile-search-active');
    });
  }
  //close search
  let mobileSearchClose = document.querySelector('#mobileSearchClose');
  if(mobileSearchClose){
    mobileSearchClose.addEventListener('click', function(){
      document.querySelector('.custom-search-wrapper').classList.remove('mobile-search-active');
    });
  }

  
  
  //trigger cart drawer toggle on icon click in responsive view
  let cart_link = document.querySelector('.cart-wrap.wrap-sec .info-link');
  if(cart_link){
    cart_link.addEventListener('click', function(){
      let cart_drawer = document.querySelector('cart-drawer');
      //console.log('cart_drawer', cart_drawer);
      cart_drawer.classList.toggle('active');
      // const changeEvent = new Event('click', {
      //   bubbles: true, 
      //   cancelable: false, 
      // });
      // trigger_cart.dispatchEvent(changeEvent);
    });
  }


  
  //featured product bfe - ATC functionality - set variant id on click
  let fp_option_wraps = document.querySelectorAll('.fp-atc-wrap .atc-options .options-wrap');
  if(fp_option_wraps){
    fp_option_wraps.forEach(function(optWrap){
      let options = optWrap.querySelectorAll('.opt-val');
      options.forEach(function(optionEle){
        optionEle.addEventListener('click', function(){
          optionEle.parentElement.querySelectorAll('.opt-val').forEach(function(e){e.classList.remove('active');});
          optionEle.classList.add('active');
          let active_option1 = document.querySelector('.fp-atc-wrap .atc-options .options-wrap:nth-child(1) .opt-val.active');
          let active_option1_text;
          if(active_option1){
            active_option1_text = active_option1.getAttribute('data-option-title');
          }
          let active_option2 = document.querySelector('.fp-atc-wrap .atc-options .options-wrap:nth-child(2) .opt-val.active');
          let active_option2_text;
          if(active_option2){
            active_option2_text = active_option2.getAttribute('data-option-title');
          }
          let active_option3 = document.querySelector('.fp-atc-wrap .atc-options .options-wrap:nth-child(3) .opt-val.active');
          let active_option3_text;
          if(active_option3){
            active_option1_text = active_option3.getAttribute('data-option-title');
          }
          let new_variant_string = '';
          if(active_option1){
            new_variant_string = `${active_option1_text}`;
          }
          if(active_option2){
            new_variant_string += ` / ${active_option2_text}`;
          }
          if(active_option3){
            new_variant_string += ` / ${active_option3_text}`;
          }
          document.querySelectorAll('select.variant-options-select-box option').forEach(function(select_opt_ele){
            let select_opt_text = select_opt_ele.textContent;
            if(select_opt_text.includes(new_variant_string)){
              let variant_id = select_opt_ele.getAttribute('value');
              document.querySelector('input.product-variant-id').value = variant_id;
            }
          });
        });
      });
    });
  }


  

  //featured products tab functionality starts
    let fp_tabLinks = document.querySelectorAll(".featured-products-tab-wrap .tablinks");
    let fp_tabContent = document.querySelectorAll(".featured-products-tab-wrap .item-cards-wrap");
  
    fp_tabLinks.forEach(function (el) {
      el.addEventListener("click", fp_openTabs);
    });
  
    function fp_openTabs(el) {
      let btnTarget = el.currentTarget;
      let id = btnTarget.dataset.id;
      fp_tabContent.forEach(function (el) {
        el.classList.remove("active");
      });
      fp_tabLinks.forEach(function (el) {
        el.classList.remove("active");
      });
      document.querySelector("#" + id).classList.add("active");
      btnTarget.classList.add("active");
    }
  
    //Create carousel for each product-list section   
    $('.featured_product_items').each( function(index, value){        
      let unique_class = 'carousel-init-'+index;
      $(this).addClass(unique_class);
      let owl = $('.'+unique_class);        
      owl.owlCarousel({
        lazyLoad:true,
        nav:true,
        dots: false,
        loop: true,
        items: 4,
        margin: 10,
        responsiveClass:true,
        responsive: {
          0: {
            items: 1.2
          },
          768: {
            items: 3
          },
          1024: {
            items: 4
          }
        }                                     
      });
    });
  
  //featured products tab functionality ends



  

  //PRODUCT PAGE FUNCTIONALITY STARTS
  
      //product tabs start
      let pt_tabLinks = document.querySelectorAll(".product-tabs .tablinks");
      let pt_tabContent = document.querySelectorAll(".product-tabs .tabcontent");
    
      pt_tabLinks.forEach(function (el) {
          el.addEventListener("click", pt_openTabs);
      });
    
      function pt_openTabs(el) {
          let btnTarget = el.currentTarget;
          let id = btnTarget.dataset.id;
          pt_tabContent.forEach(function (el) {
              el.classList.remove("active");
          });
          pt_tabLinks.forEach(function (el) {
              el.classList.remove("active");
          });
          document.querySelector("#" + id).classList.add("active");
          btnTarget.classList.add("active");
      }
      //product tabs ends
      
      //Specification dropdown functionality starts
      const specs_dropdowns = document.querySelectorAll('.dropdown-wrap .drop');
      if(specs_dropdowns){
        specs_dropdowns.forEach(function(dropEle){
          let d_btn = dropEle.querySelector('.drop-btn');
          let d_svg_icon = d_btn.querySelector('svg');
          let d_desc = dropEle.querySelector('.drop-desc');
          d_btn.addEventListener('click', function(e){
            e.target.classList.toggle('active');
            d_desc.classList.toggle('hide-desc');
            d_svg_icon.classList.toggle('rotate-icon');
          });
        });
      }
      //Specification dropdown functionality ends
  

  //PRODUCT PAGE FUNCTIONALITY STARTS ENDS
  



  
  //split product carousel functionality starts
  $('#splitCarousel1').owlCarousel({
      loop: true,
      lazyLoad: true,
      nav: true,
      navText: [
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M10.8284 12.0007L15.7782 16.9504L14.364 18.3646L8 12.0007L14.364 5.63672L15.7782 7.05093L10.8284 12.0007Z" ></path></svg>',
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M13.1717 12.0007L8.22192 7.05093L9.63614 5.63672L16.0001 12.0007L9.63614 18.3646L8.22192 16.9504L13.1717 12.0007Z" ></path></svg>'
      ],
      dots: false,
      slideBy: 1,
      items: 2.4,
      margin: 10,
      responsiveClass: true,
      responsive: {
          0: {
              items: 1.3,
              margin: 10,
          },

          768: {
                items: 1.6,
                margin: 10,
          },
          1024: {
              items: 2.4,
              margin: 10,
          }
      }
  });
  $('#splitCarousel2').owlCarousel({
     loop: true,
      lazyLoad: true,
      nav: true,
      navText: [
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M10.8284 12.0007L15.7782 16.9504L14.364 18.3646L8 12.0007L14.364 5.63672L15.7782 7.05093L10.8284 12.0007Z" ></path></svg>',
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M13.1717 12.0007L8.22192 7.05093L9.63614 5.63672L16.0001 12.0007L9.63614 18.3646L8.22192 16.9504L13.1717 12.0007Z" ></path></svg>'
      ],
      dots: false,
      slideBy: 1,
      items: 2.4,
      margin: 10,
      responsiveClass: true,
      responsive: {
          0: {
              items: 1.3,
              margin: 10,
          },

          768: {
                items: 1.6,
                margin: 10,
          },
          1024: {
              items: 2.4,
              margin: 10,
          }
      }
  });
  //split product carousel functionality ends


   //featuredProductsCarousel functionality starts
  $('#featuredProductsCarousel').owlCarousel({
      loop: true,
      lazyLoad: true,
      nav: true,
      navText: [
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M10.8284 12.0007L15.7782 16.9504L14.364 18.3646L8 12.0007L14.364 5.63672L15.7782 7.05093L10.8284 12.0007Z" ></path></svg>',
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M13.1717 12.0007L8.22192 7.05093L9.63614 5.63672L16.0001 12.0007L9.63614 18.3646L8.22192 16.9504L13.1717 12.0007Z" ></path></svg>'
      ],
      dots: false,
      slideBy: 3,
      items: 3.3,
      margin: 10,
      responsiveClass: true,
      responsive: {
          0: {
              items: 1.3,
              margin: 10,
          },
          768: {
                items: 2.3,
                margin: 10,
          },
          1024: {
                items: 3.3,
                margin: 10,
          }
      }
  });
  //featuredProductsCarousel functionality ends

  //Related products BFE Slider
  $('#relatedProductsBFE').owlCarousel({
      loop: true,
      lazyLoad: true,
      nav: true,
      navText: [
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M10.8284 12.0007L15.7782 16.9504L14.364 18.3646L8 12.0007L14.364 5.63672L15.7782 7.05093L10.8284 12.0007Z" ></path></svg>',
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M13.1717 12.0007L8.22192 7.05093L9.63614 5.63672L16.0001 12.0007L9.63614 18.3646L8.22192 16.9504L13.1717 12.0007Z" ></path></svg>'
      ],
      dots: false,
      slideBy: 1,
      items: 4.4,
      margin: 10,
      responsiveClass: true,
      responsive: {
          0: {
              items: 1.3,
              margin: 10,
          },

          768: {
                items: 2.6,
                margin: 10,
          },
          1024: {
              items: 3.4,
              margin: 10,
          }
      }
  });
  //Related products BFE Slider ends

  
  //Hero Banner 
  $('#heroSlider').owlCarousel({
      loop: true,
      lazyLoad: true,
      nav: true,
      navText: [
          '<svg class="owl-next owl-prevv-img" style="color: white" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-left-circle-fill" viewBox="0 0 16 16"> <path d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0zm3.5 7.5a.5.5 0 0 1 0 1H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5z" fill="white"></path> </svg>',
          '<svg class="owl-prew owl-prevv-img"  xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><path fill="currentColor" d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0M4.5 7.5a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5z"/></svg>',
      ],
      dots: true,
      slideBy: 1,
      items: 1,
      responsiveClass: true,
      responsive: {
          0: {
              items: 1,
              margin: 10,
          },
          768: {
              items: 1,
              margin: 10,
          }
      }
  });



  
  //search page related products
  $('#featured-slider-new').owlCarousel({
    loop: true,
    lazyLoad:true,
    nav: true,
    dots: true,
    slideBy: 1,
    items:7,
    responsiveClass:true,
    responsive:{
      0:{
        items:1.2,
          margin: 20,
      },
      768:{
        items:2,
          margin: 10,
      },
      1024:{
        items:3,
          margin: 10,
      },
      1440:{
        items:4,
          margin: 30,
      }
    }
  });


  
  // model_slider
  $('#product_model_slider').owlCarousel({
    loop: true,
    lazyLoad:true,
    nav: true,
    margin: 10,
    navText: [
      '<svg xmlns="http://www.w3.org/2000/svg" height="16" width="10" viewBox="0 0 320 512"><!--!Font Awesome Free 6.5.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2023 Fonticons, Inc.--><path d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z"/></svg>',
      '<svg xmlns="http://www.w3.org/2000/svg" height="16" width="10" viewBox="0 0 320 512"><!--!Font Awesome Free 6.5.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2023 Fonticons, Inc.--><path d="M278.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-160 160c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L210.7 256 73.4 118.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l160 160z"/></svg>',
    ],
    dots: true,
    slideBy: 1,
    items:7,
    responsiveClass:true,
    responsive:{
      0:{
        items:1.2,
      },
      768:{
        items:2,
      },
      1024:{
        items:3,
      },
      1440:{
        items:4,
      }
    }
  });


  
  //Collapsible tab functionality -  FAQ
  //accordion script start
  var acc = document.querySelectorAll("#collapsibleTab .accordion");
  for (let i = 0; i < acc.length; i++) {
    acc[i].addEventListener("click", function() {
      this.classList.toggle("current");
      var panel = this.nextElementSibling;
      if (panel.style.maxHeight) {
        panel.style.maxHeight = null;
        panel.style.paddingBottom = null;
      } else {
        let newHeight = panel.scrollHeight + 30;
        panel.style.maxHeight = newHeight + "px";
        panel.style.paddingBottom = `20px`;
      }
    });
  }
  //accordion script ends



  
  //New Card - Add to cart and Choose options functionality
  let new_card_product_all = document.querySelectorAll('.new-card-wrap.card-wrapper');
  if(new_card_product_all){
    new_card_product_all.forEach(function(ncpEle, ncpInd){      
      //ATC
      let new_card_cart_btn = ncpEle.querySelector('.new-card-cart-btn');
      if(new_card_cart_btn){
        new_card_cart_btn.addEventListener('click', function(){      
          // console.log('cart btn clicked', ncpInd);
          let addToCartBtn = ncpEle.querySelector('product-form button.quick-add__submit');
          if(addToCartBtn){
            addToCartBtn.click();
          }
        });      
      }
      //Choose Options
      let new_card_eye_btn = ncpEle.querySelector('.new-card-eye-btn');
      if(new_card_eye_btn){
        new_card_eye_btn.addEventListener('click', function(){      
          // console.log('Eye btn clicked', ncpInd);
          let quickAddBtn = ncpEle.querySelector('modal-opener button.quick-add__submit');
          if(quickAddBtn){
            let clickEvent = new Event('click', {
              bubbles: true, 
              cancelable: false, 
            });
            quickAddBtn.dispatchEvent(clickEvent);
          }
        });      
      }
    });
  }


  //All brands functionality
  // console.log('BRANDS_DATA after load: ', BRANDS_DATA);
  
  //create a new array with characters
  let BRANDS_DATA_NEW = BRANDS_DATA.map(function(bdEle){    
    let tempObj = {};
    tempObj['title'] = bdEle.title; 
    tempObj['image'] = bdEle.image; 
    tempObj['url'] = bdEle.url; 
    let new_character = bdEle.character;
    new_character = new_character.charAt(0);
    tempObj['character'] = new_character;    
    return tempObj;
  });
  //console.log('BRANDS_DATA_NEW: ', BRANDS_DATA_NEW); 

  let alphabetsArr = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];
  let alphabetLinks = ``;
  let alphabetContent = ``;
  alphabetsArr.forEach(function(alEle){    
    let active = '';
    BRANDS_DATA_NEW.forEach(function(bdnEle){
      if(bdnEle.character == alEle){
        active = 'active'
      }
    });    
    alphabetLinks += `<a class="a-link ${active}" href="javascript:void(0);" onclick="smoothScroll('#section${alEle}')">${alEle}</a>`;   
    alphabetContent += `<div class="brand-box-wrap  ${active}">
                          <div id="section${alEle}" class="alphabet-title">${alEle}</div>
                          <div class="brand-box"> </div>
                        </div>`;
  });
  let brandsAlphabet = document.querySelector('.brand-wrap .alphabets');
  if(brandsAlphabet){
    brandsAlphabet.innerHTML = alphabetLinks;    
  }
  let brandsMedia = document.querySelector('.brand-wrap .brands-media');
  if(brandsMedia){
    brandsMedia.innerHTML = alphabetContent;    
  }
  //append brands images
  setTimeout(function(){
    let all_brands = document.querySelectorAll('.brand-wrap .brand-box-wrap');
    if(all_brands){
      all_brands.forEach(function(abEle, abInd){
        let brand_box_all = ``;
        let a_title = abEle.querySelector('.alphabet-title').textContent;
        BRANDS_DATA_NEW.forEach(function(bdnEle){
          if(bdnEle.character == a_title){
              brand_box_all += `<div class="box">
                                  <img class="card-img-top" src="${bdnEle.image}" alt="${bdnEle.title}" width="auto" height="auto">
                                  <div class="brand-desc">
                                    <a href="${bdnEle.url}" class="brand-heading">${bdnEle.title}</a>
                                  </div>
                                </div>`;
          }
        }); 
        abEle.querySelector('.brand-box').innerHTML = brand_box_all;
      });
    }
  },500);
  //All brands functionality ends



  //contact page popup functionality
  let cPopupBtn = document.querySelector('.contact-popup-wrapper #contactPopupBtn');
  if(cPopupBtn){
    cPopupBtn.addEventListener('click', function(){
      document.querySelector('.form_wrapper').classList.add('show');
    });
  }
  let cPopupCloseBtn = document.querySelector('.contact-popup-wrapper .form_close');
  if(cPopupCloseBtn){
    cPopupCloseBtn.addEventListener('click', function(){
      document.querySelector('.form_wrapper').classList.remove('show');
    });
  }


  //Product page get a quote functionality
  let getQuoteBtn = document.querySelector('button.get-quote-btn');
  if(getQuoteBtn){
    getQuoteBtn.addEventListener('click', function(){
      document.querySelector('.form_wrapper').classList.add('show');
    });

    const url_params = new URLSearchParams(window.location.search);
    const contact_posted = url_params.get('contact_posted'); // Gets the value of the "name" parameter
    // console.log('contact_posted', contact_posted);
    if(contact_posted){
      // let getQuoteBtn = document.querySelector('.atc-compare-wrap #getQuoteBtn');
      // console.log('getQuoteBtn', getQuoteBtn)
      getQuoteBtn.click();
      // getQuoteBtn.dispatchEvent('click');
    }
  }
  let quotePopupCloseBtn = document.querySelector('#getQuotePopup .form_close');
  if(quotePopupCloseBtn){
    quotePopupCloseBtn.addEventListener('click', function(){
      document.querySelector('.form_wrapper').classList.remove('show');
    });
  }




  








  //add test class for ATC and Wishlist btn
  let currentPathNew = window.location.pathname;
  if(currentPathNew.includes('winco-rc-s300-advance-electric-30-cups-rice-cooker-warmer')){
    document.querySelector('body').classList.add('primary-color-scheme');
  }
  // if(currentPath.includes('apple-watch-series-5')){
  //   document.querySelector('body').classList.add('secondary-color-scheme');
  // }

 
  //Wishlist functionality
  setTimeout(function(){
    let wishlistBtnBadge = document.querySelector('#wishlisthero-floating-launcher-container span.MuiBadge-badge').textContent;
    //console.log('wishlistBtnBadge', wishlistBtnBadge);
    if(wishlistBtnBadge){
      if(wishlistBtnBadge > 0){
        document.querySelector('.wishlist-count-bubble').style.display = 'flex';
        document.querySelector('.wishlist-count-bubble .count').textContent = wishlistBtnBadge;
      }else{
        document.querySelector('.wishlist-count-bubble').style.display = 'none';
        document.querySelector('.wishlist-count-bubble .count').textContent = wishlistBtnBadge;
      }
    }
  }, 1000);

  //open wishlist app popup on click
  let wishlistIconWrap = document.querySelector('.wishlist-wrap .icon-wrap');
  let wishlistIconLink = document.querySelector('.wishlist-wrap .text .info-link');  
  
  wishlistIconWrap.addEventListener('click', function(){
    let wishlistFloatingBtn = document.querySelector('span.MuiBadge-root a[aria-label="Open Wishlist"]');
    wishlistFloatingBtn.click();
  });

  wishlistIconLink.addEventListener('click', function(e){
    e.preventDefault();
    let wishlistFloatingBtn = document.querySelector('span.MuiBadge-root a[aria-label="Open Wishlist"]');
    wishlistFloatingBtn.click();
  });


  //card product trigger item add to wishlist app
  
  // var productInfo = {
  //   CustomerId: number,
  //   ProductId: number,
  //   ProductTitle: string,
  //   ProductPrice: number,
  //   ProductLink: string,
  //   ProductVariantId: number,
  //   ProductImage: string,
  //   WishlistHash: string
  // };
  // var added = await window.WishListHero_SDK.AddWishListItem(productInfo)

  let card_all_like_btns = document.querySelectorAll('.circle-btn.like');
  
  if(card_all_like_btns){
    card_all_like_btns.forEach(function(cardLikeBtnEle){
      cardLikeBtnEle.addEventListener('click', function(e){
        
        //get the product data
        let productInfo = {
          CustomerId: cardLikeBtnEle.getAttribute('data-customer-id'),
          ProductId: cardLikeBtnEle.getAttribute('data-product-id'),
          ProductTitle: cardLikeBtnEle.getAttribute('data-product-title'),
          ProductPrice: cardLikeBtnEle.getAttribute('data-product-price'),
          ProductLink: cardLikeBtnEle.getAttribute('data-product-url'),
          ProductVariantId: cardLikeBtnEle.getAttribute('data-variant-id'),
          ProductImage: cardLikeBtnEle.getAttribute('data-product-image'),
          WishlistHash: window.WishListHero_SDK.GetWishListHash()
        };
        console.log('productInfo', productInfo);
        // let added = await window.WishListHero_SDK.AddWishListItem(productInfo);
        
      });
    });
  }

  
  
  
  



  
  
  
  
  
    
}, false);


//this will only work on a paid plan
// document.addEventListener("wishlist-hero-wishlist-sdk-ready", async function (e) {
//   //wishlist count
//   let wishlistCount = window.WishListHero_SDK.GetWishListItemsCount();
//   console.log('wishlistCount', wishlistCount);
// });

  



